export default __webpack_public_path__ + "static/media/pinErr.4ce0debe.svg";